import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Radiobutton from './radio/Radiobutton';

interface TrueImpactRadioProps<T> {
  selectedOption: T | undefined;
  nullText?: ReactNode;
  options: T[];
  className?: string;
  radioClassName?: string;
  compare: (current: T, selected: T | undefined) => boolean;
  getId: (o: T) => string | number;
  getLabel: (o: T, isItemSelected: boolean) => ReactNode;
  onChange: (o: T) => unknown;
}

const StyledDiv = styled.div``;

const TrueImpactRadio = <T,>({
  nullText,
  options,
  selectedOption,
  className,
  radioClassName,
  getId,
  getLabel,
  compare,
  onChange,
}: TrueImpactRadioProps<T>) => {
  if (options.length === 0) {
    return <StyledDiv className={className}>{nullText}</StyledDiv>;
  }
  return (
    <StyledDiv className={className}>
      {options.map(o => {
        const check = compare(o, selectedOption);
        return (
          <Radiobutton
            key={getId(o)}
            check={check}
            className={radioClassName}
            text={getLabel(o, check)}
            onClick={() => onChange(o)}
          />
        );
      })}
    </StyledDiv>
  );
};

export default TrueImpactRadio;
